import { connect } from "react-redux";
import SalesforceTimelineStatusSettingEdit from "../components/AccountSetting/Salesforce/SalesforceTimelineStatusSetting/SalesforceTimelineStatusSettingEdit";
import { goBack, push, replace } from "react-router-redux";
import * as actions from "../redux/actions/Salesforce";
import { getUser } from "../redux/actions/AccountSetting";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  errorMessage: state.sfdcTimelineStatusSetting.errorMessage,
  shortMessage: state.sfdcTimelineStatusSetting.shortMessage,
  successMessage: state.sfdcTimelineStatusSetting.successMessage,
  // クライアントのSalesforce上のマッピング項目の候補をロード中かどうか
  isLoadingFields: state.sfdcTimelineStatusSetting.isLoadingFields,
  eventFields: state.sfdcTimelineStatusSetting.eventFields,
  expiredAccessError: state.sfdcTimelineStatusSetting.expiredAccessError,
  // DBに保存しているマッピングの情報ロード中かどうか
  isLoadingMapping: state.sfdcTimelineStatusSetting.isLoadingMapping,
  mapping: state.sfdcTimelineStatusSetting.mapping,
  // DBにマッピング保存中かどうか
  isConfiguring: state.sfdcTimelineStatusSetting.isConfiguring,
});

const mapDispatchToProps = (dispatch) => ({
  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  replace(url, state) {
    dispatch(replace(url, state));
  },

  getUserInfo() {
    dispatch(getUser(true));
  },

  getSalesforceDescribeTimelineStatusExport() {
    dispatch(actions.getSalesforceDescribeTimelineStatusExport());
  },

  getSalesforceExportMappings(data) {
    dispatch(actions.getSalesforceExportMappings(data));
  },

  postSalesforceExportMappingsTimelineStatus(data) {
    dispatch(actions.postSalesforceExportMappingsTimelineStatus(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceTimelineStatusSettingEdit);



// WEBPACK FOOTER //
// ./src/containers/SalesforceTimelineStatusSettingEdit.js